  import React, { useState, useEffect } from "react"; 
  import { useNavigate } from "react-router-dom";
  import axios from "axios";
  import APIURL from "../../common/Config";
  import "../call-chat/chat.css";
  import defaultProfileImage from "../../assets/profilechat.webp";
  import chatImage from "../../assets/profilechat.webp";
  import Header from "../header/header";
  import Footer from "../footer/footer";
  import ChatBanner from "../home/baner";
  import toast from 'react-hot-toast';
  import { useDispatch } from "react-redux";
  import { openAuthModal } from "../../redux/authSlice";
  const AstrologerProfile = ({
    image,
    stars,    
    orders,
    name,
    gender,
    details,
    experience,
    Age,
    rate,
    isWaiting,
    astrologerId,
    chatStatus,
    isFollowing,
  onFollowToggle,
  }) => {
    const [profileImage, setProfileImage] = useState(image || defaultProfileImage);
    const [balanceModal, setBalanceModal] = useState({ show: false, msg: "" });
    const navigate = useNavigate(); 
  const dispatch = useDispatch();


  const handleOpenChat = async () => {
    const isLoggedInRaw = localStorage.getItem("isLoggedIn");
    const customerIdRaw = localStorage.getItem("customerId");
    const isLoggedValid = (isLoggedInRaw === "true" || isLoggedInRaw === true);
    const hasIdentity = (customerIdRaw && customerIdRaw !== "0");

    if (!(isLoggedValid && hasIdentity)) {
        toast.error("Please login to continue.");
        dispatch(openAuthModal('login'));
        return;
    }

    if (chatStatus != 2) {
        toast.error("Astrologer is currently offline.");
        return;
    }

    try {
        const customerId = localStorage.getItem("customerId");
        // Dhyaan de: Native app ki tarah hum check kar rahe hain
        const balanceRes = await axios.get(
            `${APIURL}/astrochat2026/verifybalance/CHAT/${customerId}/${astrologerId}`
        );
        const data = balanceRes.data;

        // Agar API "PAYMENT" bol rahi hai, iska matlab na free chat hai na balance
        if (data.callAction === "PAYMENT") {
            setBalanceModal({ show: true, msg: data.msg });
            return; 
        }

        // Agar PAYMENT nahi aaya, toh seedha Inquiry Form pe bhejo
        localStorage.setItem("astrologerName", name);
        localStorage.setItem("astrologerImage", image || defaultProfileImage);
        navigate(`/inquary/${astrologerId}`, { 
            state: { astrologerName: name, astrologerImage: image } 
        });

    } catch (err) {
        toast.error("Unable to verify balance. Please try again.");
    }
};
//  const handleOpenChat = async () => {
//       console.log("--- START DEBUGGING CHAT CLICK ---");

//       // 1. Raw Values check karein
//       const isLoggedInRaw = localStorage.getItem("isLoggedIn");
//       const phoneNumberRaw = localStorage.getItem("phoneNumber");
//       const customerIdRaw = localStorage.getItem("customerId");
      
//       const allKeys = Object.keys(localStorage);

//       console.log("1. Raw isLoggedIn from Storage:", isLoggedInRaw, "| Type:", typeof isLoggedInRaw);
//       console.log("2. Raw phoneNumber from Storage:", phoneNumberRaw);
//       console.log("3. Raw customerId from Storage:", customerIdRaw);
//       console.log("4. All Keys present in LocalStorage:", allKeys);

//       // 2. Logic Check
//       const isLoggedValid = (isLoggedInRaw === "true" || isLoggedInRaw === true);
//       const hasIdentity = (phoneNumberRaw || (customerIdRaw && customerIdRaw !== "0"));

//       console.log("5. isLoggedValid (Boolean Check):", isLoggedValid);
//       console.log("6. hasIdentity (Phone/ID Check):", hasIdentity);
//       console.log("7. Final isAuthenticated Result:", (isLoggedValid && hasIdentity));
//       console.log("8. Astrologer Status:", chatStatus);

//       if (!(isLoggedValid && hasIdentity)) {
//           console.error("DEBUG: Authentication Failed. Redirecting to Signup.");
//           toast.error("Please login to continue.");
//           // navigate('/signup'); 
//           dispatch(openAuthModal('login'));
//       } 
//       else if (chatStatus != 2) {
//           console.warn("DEBUG: User Auth OK, but Astrologer Offline.");
//           toast.error("Astrologer is currently offline.");
//       } 
//       else {
//           console.log("DEBUG: Everything OK. Navigating to Inquiry.");
//           localStorage.setItem("astrologerName", name);
//           localStorage.setItem("astrologerImage", image || defaultProfileImage);
          
//           try {
//   const customerId = localStorage.getItem("customerId");
//   const balanceRes = await axios.get(
//     `${APIURL}/astrochat2026/verifybalance/CHAT/${customerId}/${astrologerId}`
//   );
//   const data = balanceRes.data;

//   if (data.callAction === "PAYMENT") {
//   setBalanceModal({ show: true, msg: data.msg });
//   return;
// }
// } catch (err) {
//   toast.error("Unable to verify balance. Please try again.");
//   return;
// }

//           navigate(`/inquary/${astrologerId}`, { 
//               state: { astrologerName: name, astrologerImage: image } 
//           });
//       }
//       console.log("--- END DEBUGGING CHAT CLICK ---");
//   };
  

  return (
    <>
       {balanceModal.show && (
        <div className="balance-modal-overlay">
          <div className="balance-modal-box">
            <button className="balance-modal-close" onClick={() => setBalanceModal({ show: false, msg: "" })}>✕</button>
            <div className="balance-modal-icon">💰</div>
            <h3 className="balance-modal-title">Insufficient Balance</h3>
            <p className="balance-modal-msg">{balanceModal.msg}</p>
            <button className="balance-modal-btn" onClick={() => { setBalanceModal({ show: false, msg: "" }); navigate("/wallet"); }}>
              Recharge Now
            </button>
          </div>
        </div>
      )}
      <div className="astrologer-chat">
        {/* <div className="profile">
          <img src={profileImage} alt={name} className="profile-image" />
        </div> */}
        <div className="profile">
  <img src={profileImage} alt={name} className="profile-image" />
  <button
    className={`follow-btn ${isFollowing ? "follow-btn-following" : "follow-btn-follow"}`}
    onClick={(e) => { e.stopPropagation(); onFollowToggle(astrologerId); }}
  >
    {isFollowing ? "Following" : "Follow"}
  </button>
</div>
        <div className="content">
          <p className="name">{name}</p>
          <p className="details">{details}</p>
          <p className="genders">Gender: {gender}</p>
          <p className="Age">Age: {Age}</p>
          <div className="chatbutton">
      <p className="experience">Exp: {experience} Years</p>
      <button 
          className={`chat-button
            
            `} 
          onClick={handleOpenChat} 
      >
          {"Chat"}
      </button>
  </div>
        
          <p className="rate">
            <span>₹ {rate}/min</span> 
          </p>
        </div>

        
        <div className={`card-status ${chatStatus === 2 ? 'Live' : 'offline'}`}>
        <div className="status-dot"></div>
      </div>
      </div>
      </>
    );
  };

  const AstrologerGrid = () => {
    const [astrologers, setAstrologers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
   const [searchQuery, setSearchQuery] = useState("");
    const [activeFilter, setActiveFilter] = useState("all");
    const [followStatus, setFollowStatus] = useState({});
const dispatch = useDispatch();
  

    const handleFollowUnfollow = async (astrologerId) => {
  const isLoggedInRaw = localStorage.getItem("isLoggedIn");
  const customerId = localStorage.getItem("customerId");
  const isLoggedValid = (isLoggedInRaw === "true" || isLoggedInRaw === true);

  if (!isLoggedValid || !customerId) {
    toast.error("Please login to continue.");
    dispatch(openAuthModal('login'));
    return;
  }

 const currentlyFollowing = followStatus[astrologerId] || false;
  const url = `${APIURL}/astro/followers/${currentlyFollowing ? 'unfollow' : 'follow'}?astrologerId=${astrologerId}&customerId=${customerId}`;
  const method = currentlyFollowing ? 'delete' : 'post';

  const astrologerName = astrologers.find(a => a.astrologerId === astrologerId)?.name || "Astrologer";

  try {
    await axios({ method, url, headers: { 'Accept': '*/*' } });
    setFollowStatus((prev) => ({
      ...prev,
      [astrologerId]: !currentlyFollowing,
    }));
    toast.success(currentlyFollowing ? `Unfollowed ${astrologerName}` : `Following ${astrologerName}! `);
  } catch (error) {
    toast.error("Follow/Unfollow failed. Try again.");
  }
};


  useEffect(() => {
      const fetchAstrologers = async () => {
        try {
          // --- IMPROVEMENT START ---
          // LocalStorage se customerId uthao, agar nahi hai to '0' bhejo
          const storedCustomerId = localStorage.getItem("customerId") || "0";
          
          const response = await axios.get(
            `${APIURL}/astroservice/list/astrologer/loggedin?customerId=${storedCustomerId}`
          );
          // --- IMPROVEMENT END ---

          const rawData = response.data; 
          const active = rawData.filter((a) => a.status === 1);

          const formattedAstrologers = active.map((astrologer) => ({
            image: astrologer.photoUrlpath || chatImage,
            stars: "★★★★★",
            orders: astrologer.chatCount || 0,
            name: astrologer.firstName,
            gender: astrologer.gender,
            details: `${astrologer.specialization} | ${astrologer.language}`,
            Age: `${astrologer.age} yr`,
            experience: astrologer.experience,
            rate: astrologer.chatCharges,
            isWaiting: astrologer.chatStatus === 2,
            astrologerId: astrologer.astrologerId,
            chatStatus: astrologer.chatStatus,
            following: astrologer.following || false,
          }));

          setAstrologers(formattedAstrologers);
          const initialFollow = {};
formattedAstrologers.forEach(a => {
  initialFollow[a.astrologerId] = a.following || false;
});
setFollowStatus(initialFollow);
        } catch (err) {
          setError("Error fetching astrologers");
          console.error("Error fetching astrologers:", err);
        } finally {
          setLoading(false);
        }
      };

      fetchAstrologers();
    }, []);
    const filtered = astrologers
      .filter((a) => {
        if (activeFilter === "active") return a.chatStatus === 2;
        if (activeFilter === "inactive") return a.chatStatus !== 2;
        return true;
      })
      .filter((a) =>
        a.name?.toLowerCase().includes(searchQuery.toLowerCase())
      );
    if (loading) return <div className="loading-container"><p>Loading Astrologers...</p></div>;
    if (error) return <div className="error-container"><p>{error}</p></div>;

    return (
      <>
     <div className="ag-controls">
           <div className="ag-header-row">
            <div className="ag-title-block">
              <div>
              {/* <h2 className="ag-title">Chat with our Expert 
                <br />
                Astrologers</h2> */}
                <h2 className="ag-title">
  Chat with our{" "}
  <span style={{ color: "#89184a" }}>Expert</span>
  <br />Astrologers
</h2>
                <p className="ag-subtitle">
      Connect with India's most trusted spiritual guides for deep insights
      into your birth chart, career, and love life.
    </p>
              </div>
              <span className="ag-count">{filtered.length} Available</span>
            </div>
            <div className="ag-search-wrap">
              <svg className="ag-search-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
              </svg>
              <input
                className="ag-search-input"
                type="text"
                placeholder="Search by name..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                autoComplete="off"
              />
              {searchQuery && (
                <button className="ag-search-clear" onClick={() => setSearchQuery("")}>✕</button>
              )}
            </div>
            <div className="ag-toggle-wrap">
              {[
                { key: "all", label: "All" },
                { key: "active", label: "Live" },
                { key: "inactive", label: "Offline" },
              ].map((f) => (
                <button
                  key={f.key}
                  className={`ag-toggle-btn ${activeFilter === f.key ? "ag-toggle-active" : ""}`}
                  onClick={() => setActiveFilter(f.key)}
                >
                  <span className={`ag-dot ${f.key === "active" ? "ag-dot-green" : f.key === "inactive" ? "ag-dot-red" : "ag-dot-grey"}`}></span>
                  {f.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        {filtered.length === 0 ? (
          <div className="ag-empty">
            <p>No astrologers found</p>
          </div>
        ) : null}
      <div className="container-main">
        {filtered.map((astrologer, index) => (
          // <AstrologerProfile key={astrologer.astrologerId || index} {...astrologer} />
          <AstrologerProfile 
  key={astrologer.astrologerId || index} 
  {...astrologer}
  isFollowing={followStatus[astrologer.astrologerId] || false}
  onFollowToggle={handleFollowUnfollow}
/>
        ))}
        
      </div>
      </>
    );
  };

  function App() {
    
  const staticMeta = {
      title: "AstroBhagya – Chat with Astrologer Online - Talk to Astrologer free",
      description: "Chat with astrologer online anytime! Get expert astrology guidance, live astrology chat service, and personalized online astrologer consultation 24x7.",
      keywords: "Chat with Astrologer Online, Online astrologer consultation, Talk to astrologer online, Online astrology chat service, Astrology guidance, Astrology chat with expert",
      author: "Heavenly Expectation Private Limited",
      revisitAfter: "7 days",
      distribution: "global",
      rating: "general",
    };

    useEffect(() => {
      
      document.title = staticMeta.title;

      
      const setOrCreateMetaTag = (name, content) => {
        let metaTag = document.querySelector(`meta[name="${name}"]`);
        if (metaTag) {
          metaTag.setAttribute("content", content);
        } else {
          metaTag = document.createElement('meta');
          metaTag.setAttribute("name", name);
          metaTag.setAttribute("content", content);
          document.head.appendChild(metaTag);
        }
      };

      
      setOrCreateMetaTag("description", staticMeta.description);
      setOrCreateMetaTag("keywords", staticMeta.keywords);
      setOrCreateMetaTag("author", staticMeta.author);
      setOrCreateMetaTag("revisit-after", staticMeta.revisitAfter);
      setOrCreateMetaTag("distribution", staticMeta.distribution);
      setOrCreateMetaTag("rating", staticMeta.rating);

      
      let charsetMeta = document.querySelector('meta[charset]');
      if (!charsetMeta) {
          charsetMeta = document.createElement('meta');
          charsetMeta.setAttribute('charset', 'UTF-8');
          document.head.prepend(charsetMeta); 
      }

    }, []); 

    return (
      <div className="App">
        
        <Header />
        <AstrologerGrid />
        <ChatBanner />
        <br></br>
        <Footer /> 
        
      </div>
    );
  }

  export default App;